export default __webpack_public_path__ + "static/media/icoInstagram.fb45c860.svg";